<!-- Main Container -->
<div class="min-h-screen bg-gray-50">
  <!-- Sticky Header Section -->
  <header class="sticky top-[60px] z-40 bg-white shadow-sm">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
      <!-- Mobile Layout -->
      <div class="sm:hidden space-y-4">
        <div>
          <h1 class="text-xl font-bold text-gray-900">Vendor Dashboard</h1>
          <p class="mt-1 text-sm text-gray-500">Manage your assigned tasks and work orders</p>
        </div>
        <div class="flex flex-col space-y-2">
          <div class="flex items-center justify-between">
            <div class="text-sm text-gray-500">
              Last updated: {{lastUpdateTime | date:'short'}}
            </div>
            <div class="text-sm text-gray-500">
              Next update in: {{getTimeUntilNextPoll()}}
            </div>
          </div>
          <button (click)="refreshData()" 
                  class="w-full inline-flex items-center justify-center px-3 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            <svg class="h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            Refresh Data
          </button>
        </div>
      </div>

      <!-- Desktop Layout -->
      <div class="hidden sm:flex justify-between items-center">
        <div>
          <h1 class="text-2xl font-bold text-gray-900">Vendor Dashboard</h1>
          <p class="mt-1 text-sm text-gray-500">Manage your assigned tasks and work orders</p>
        </div>
        <div class="flex items-center space-x-4">
          <div class="flex items-center space-x-2">
            <div class="text-sm text-gray-500">
              Last updated: {{lastUpdateTime | date:'short'}}
            </div>
            <div class="text-sm text-gray-500">
              Next update in: {{getTimeUntilNextPoll()}}
            </div>
            <button (click)="refreshData()" 
                    class="inline-flex items-center px-2 py-1 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
              <svg class="h-4 w-4 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              Refresh
            </button>
          </div>
        </div>
      </div>
    </div>
  </header>

  <!-- Main Content -->
  <div class="pt-4">
    <!-- Metrics Section -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div class="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-2">
        <!-- Active Tasks Card -->
        <div class="bg-white overflow-hidden shadow rounded-lg">
          <div class="p-5">
            <div class="flex items-center">
              <div class="flex-shrink-0 bg-indigo-500 rounded-md p-3">
                <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
              </div>
              <div class="ml-5 w-0 flex-1">
                <dl>
                  <dt class="text-sm font-medium text-gray-500 truncate">Active Tasks</dt>
                  <dd class="flex items-baseline">
                    <div class="text-2xl font-semibold text-gray-900">{{taskMetrics.active}}</div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <!-- Unread Tasks Card -->
        <div class="bg-white overflow-hidden shadow rounded-lg">
          <div class="p-5">
            <div class="flex items-center">
              <div class="flex-shrink-0 bg-blue-500 rounded-md p-3">
                <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                </svg>
              </div>
              <div class="ml-5 w-0 flex-1">
                <dl>
                  <dt class="text-sm font-medium text-gray-500 truncate">Unread Tasks</dt>
                  <dd class="flex items-baseline">
                    <div class="text-2xl font-semibold text-gray-900">{{getUnreadCount()}}</div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Filters and Search Section -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div class="bg-white shadow rounded-lg p-4">
        <div class="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0 sm:space-x-4">
          <!-- Search Input -->
          <div class="w-full sm:w-96">
            <div class="relative rounded-md shadow-sm">
              <input type="text" 
                     [(ngModel)]="searchTerm"
                     (input)="onSearchInput($event)"
                     class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-4 pr-12 sm:text-sm border-gray-300 rounded-md"
                     placeholder="Search tasks...">
              <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
            </div>
          </div>

          <!-- Filter Buttons -->
          <div class="flex space-x-4">
            <button (click)="filterByUrgent()" 
                    [class.bg-indigo-600]="urgentFilter"
                    [class.text-white]="urgentFilter"
                    class="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
              <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
              Urgent
            </button>

            <button (click)="filterByUnread()"
                    [class.bg-indigo-600]="unreadFilter"
                    [class.text-white]="unreadFilter"
                    class="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
              <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
              Unread
              <span *ngIf="getUnreadCount() > 0" 
                    class="ml-1.5 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
                    [ngClass]="{'bg-indigo-100 text-indigo-800': !unreadFilter, 'bg-white text-indigo-600': unreadFilter}">
                {{getUnreadCount()}}
              </span>
            </button>

            <!-- View Toggle -->
            <div class="flex rounded-md shadow-sm">
              <button (click)="toggleViewMode('list')"
                      [class.bg-indigo-600]="viewMode === 'list'"
                      [class.text-white]="viewMode === 'list'"
                      class="relative inline-flex items-center px-3 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
                <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                </svg>
              </button>
              <button (click)="toggleViewMode('grid')"
                      [class.bg-indigo-600]="viewMode === 'grid'"
                      [class.text-white]="viewMode === 'grid'"
                      class="relative inline-flex items-center px-3 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
                <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Task List Section -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <!-- Loading State -->
      <div *ngIf="isLoading" class="flex justify-center items-center py-12">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>

      <!-- No Data State -->
      <ng-container *ngIf="!isLoading">
        <div *ngIf="(vendorTasks$ | async)?.length === 0" class="text-center py-12">
          <svg class="mx-auto h-12 w-12 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <h3 class="mt-2 text-sm font-medium text-gray-900">No tasks found</h3>
          <p class="mt-1 text-sm text-gray-500">You have no assigned tasks at the moment.</p>
        </div>

        <!-- Task List -->
        <ng-container *ngIf="(vendorTasks$ | async) as tasks">
          <!-- Mobile Card View -->
          <div class="sm:hidden space-y-4">
            <div *ngFor="let task of tasks | slice:(currentPage-1)*itemsPerPage:currentPage*itemsPerPage" 
                 class="relative bg-white border border-gray-200 rounded-xl shadow-lg ring-1 ring-indigo-100 hover:shadow-2xl hover:ring-indigo-200 transition-all duration-300">
              <div class="absolute left-0 top-0 h-full w-1 bg-teal-300 rounded-l-xl"></div>
              <!-- Card Header -->
              <div class="p-4 border-b border-gray-100">
                <div class="flex items-center justify-between">
                  <div class="flex items-center space-x-3">
                    <div class="h-10 w-10 rounded-full bg-indigo-100 flex items-center justify-center">
                      <span class="text-indigo-600 font-medium">{{task.servicesOffered.charAt(0)}}</span>
                    </div>
                    <div>
                      <div class="flex items-center">
                        <span class="text-sm font-medium text-gray-900">RO #{{task.roNumber}}</span>
                        <div *ngIf="isTaskUnread(task)" class="ml-2">
                          <span class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-yellow-100 text-orange-700 animate-pulse">
                            New
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full" [ngClass]="getTaskFlagClass(task)">
                    {{getTaskFlagStatus(task)}}
                  </span>
                </div>
              </div>

              <!-- Card Body -->
              <div class="p-4">
                <div class="grid grid-cols-2 gap-4">
                  <!-- Left Column -->
                  <div class="space-y-3">
                    <div class="flex items-center text-sm">
                      <svg class="h-4 w-4 text-gray-400 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                      </svg>
                      <div>
                        <p class="text-gray-900">{{getAssignedByTenant(task)}}</p>
                        <p class="text-gray-500">{{getAssignedByContact(task)}}</p>
                      </div>
                    </div>
                  </div>

                  <!-- Right Column -->
                  <div class="space-y-3">
                    <div class="flex items-center text-sm">
                      <svg class="h-4 w-4 text-gray-400 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                      <span class="text-gray-900">{{getServiceOffered(task)}}</span>
                    </div>

                    <div class="flex items-center text-sm">
                      <svg class="h-4 w-4 text-gray-400 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span class="text-gray-900">{{getTimeSinceCreation(task)}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Card Footer -->
              <div class="px-4 py-3 bg-gray-50 rounded-b-lg flex justify-end space-x-3">
                <button (click)="selectTask(task); $event.stopPropagation()" 
                        class="text-gray-500 hover:text-gray-700">
                  View Details
                </button>
                <button (click)="acknowledgeCompletion(task); $event.stopPropagation()"
                        [disabled]="task.taskCompleted"
                        class="text-green-600 hover:text-green-900 disabled:opacity-50 disabled:cursor-not-allowed">
                  {{task.taskCompleted ? 'Completed' : 'Complete'}}
                </button>
              </div>
            </div>
          </div>

          <!-- Desktop Table View -->
          <div class="hidden sm:block bg-white shadow overflow-hidden sm:rounded-lg">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Task Details
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Assigned By
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Service
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Time
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th scope="col" class="relative px-6 py-3">
                    <span class="sr-only">Actions</span>
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr *ngFor="let task of tasks | slice:(currentPage-1)*itemsPerPage:currentPage*itemsPerPage" 
                    class="hover:bg-gray-50 cursor-pointer"
                    (click)="selectTask(task)">
                  <td class="px-6 py-4">
                    <div class="flex items-center">
                      <div class="flex-shrink-0 h-10 w-10">
                        <div class="h-10 w-10 rounded-full bg-indigo-100 flex items-center justify-center">
                          <span class="text-indigo-600 font-medium">{{task.servicesOffered.charAt(0)}}</span>
                        </div>
                      </div>
                      <div class="ml-4">
                        <div class="flex items-center">
                          <div class="text-sm text-gray-500 font-medium">
                            RO #{{task.roNumber}}
                          </div>
                          <div *ngIf="isTaskUnread(task)" class="ml-2">
                            <span class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-yellow-100 text-orange-700 animate-pulse">
                              New
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="text-sm text-gray-900">{{getAssignedByTenant(task)}}</div>
                    <div class="text-sm text-gray-500">{{getAssignedByContact(task)}}</div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="text-sm text-gray-900">{{getServiceOffered(task)}}</div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="text-sm text-gray-900">{{getTimeSinceCreation(task)}}</div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full" [ngClass]="getTaskFlagClass(task)">
                      {{getTaskFlagStatus(task)}}
                    </span>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <div class="flex justify-end space-x-2">
                      <button (click)="selectTask(task); $event.stopPropagation()" 
                              class="text-gray-500 hover:text-gray-700">
                        View
                      </button>
                      <button (click)="acknowledgeCompletion(task); $event.stopPropagation()"
                              [disabled]="task.taskCompleted"
                              class="text-green-600 hover:text-green-900 disabled:opacity-50 disabled:cursor-not-allowed">
                        {{task.taskCompleted ? 'Completed' : 'Complete'}}
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6 mt-6">
            <div class="flex-1 flex justify-between sm:hidden">
              <button (click)="previousPage()"
                      [disabled]="currentPage === 1"
                      class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                Previous
              </button>
              <button (click)="nextPage()"
                      [disabled]="currentPage === totalPages"
                      class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                Next
              </button>
            </div>
            <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
              <div>
                <p class="text-sm text-gray-700">
                  Showing page <span class="font-medium">{{currentPage}}</span> of <span class="font-medium">{{totalPages}}</span>
                </p>
              </div>
              <div>
                <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                  <button (click)="previousPage()"
                          [disabled]="currentPage === 1"
                          class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                    <span class="sr-only">Previous</span>
                    <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                    </svg>
                  </button>
                  <button (click)="nextPage()"
                          [disabled]="currentPage === totalPages"
                          class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                    <span class="sr-only">Next</span>
                    <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                  </button>
                </nav>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <!-- Task Detail Slide-out -->
    <div *ngIf="selectedTask" 
         class="fixed inset-0 overflow-hidden z-50"
         [@slideInOut]="selectedTask ? 'in' : 'out'">
      <div class="absolute inset-0 overflow-hidden">
        <!-- Backdrop -->
        <div class="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity" (click)="selectTask(null)"></div>
        
        <!-- Slide-out Panel -->
        <div class="fixed inset-y-0 right-0 pl-10 max-w-full flex">
          <div class="w-screen max-w-2xl">
            <div class="h-full flex flex-col bg-white shadow-xl">
              <!-- Header -->
              <div class="sticky top-0 z-10 bg-white border-b border-gray-200">
                <div class="px-6 py-4 flex items-center justify-between">
                  <div>
                    <h2 class="text-xl font-semibold text-gray-900">Request Details</h2>
                    <p class="mt-1 text-sm text-gray-500">RO #{{selectedTask.roNumber}}</p>
                  </div>
                  <button (click)="selectTask(null)" 
                          class="rounded-full p-2 hover:bg-gray-100 text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-200">
                    <span class="sr-only">Close panel</span>
                    <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              </div>

              <!-- Content -->
              <div class="flex-1 overflow-y-auto">
                <div class="px-6 py-4 space-y-6">
                  <!-- Status and Priority -->
                  <div class="flex items-center justify-between">
                    <div class="flex items-center space-x-4">
                      <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full" [ngClass]="getTaskFlagClass(selectedTask)">
                        {{getTaskFlagStatus(selectedTask)}}
                      </span>
                      <span *ngIf="isTaskUnread(selectedTask)" 
                            class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-yellow-100 text-orange-700">
                        New
                      </span>
                    </div>
                    <div class="text-sm text-gray-500">
                      Created {{getTimeSinceCreation(selectedTask)}}
                    </div>
                  </div>

                  <!-- Basic Information -->
                  <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <h3 class="text-lg font-medium text-gray-900 mb-4">Request Information</h3>
                    <dl class="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-6">
                      <div>
                        <dt class="text-sm font-medium text-gray-500">Location</dt>
                        <dd class="mt-1 text-sm text-gray-900">{{getAssignedByTenant(selectedTask)}}</dd>
                      </div>
                      <div>
                        <dt class="text-sm font-medium text-gray-500">Contact</dt>
                        <dd class="mt-1 text-sm text-gray-900">{{getAssignedByContact(selectedTask)}}</dd>
                      </div>
                      <div>
                        <dt class="text-sm font-medium text-gray-500">Service Type</dt>
                        <dd class="mt-1">
                          <span class="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                            {{getServiceOffered(selectedTask)}}
                          </span>
                        </dd>
                      </div>
                      <div>
                        <dt class="text-sm font-medium text-gray-500">RO Number</dt>
                        <dd class="mt-1 text-sm text-gray-900">{{selectedTask.roNumber}}</dd>
                      </div>
                    </dl>
                  </div>

                  <!-- Description -->
                  <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <h3 class="text-lg font-medium text-gray-900 mb-4">Description</h3>
                    <div class="prose prose-sm max-w-none text-gray-900">
                      <p>{{getTaskDescription(selectedTask)}}</p>
                    </div>
                  </div>

                  <!-- Attachments -->
                  <div *ngIf="selectedTask.media?.length" class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <h3 class="text-lg font-medium text-gray-900 mb-4">Attachments</h3>
                    <div class="grid grid-cols-2 md:grid-cols-3 gap-4">
                      <div *ngFor="let media of selectedTask.media; let i = index" 
                           (click)="openImageViewer(media, i, $event)"
                           class="relative group aspect-square rounded-lg overflow-hidden bg-gray-100 cursor-pointer hover:ring-2 hover:ring-indigo-500 transition-all duration-200">
                        <img [src]="media.imageUrl" 
                             [alt]="media.caption || 'Attachment'"
                             class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105">
                        <div class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-opacity duration-300"></div>
                        <div class="absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black/60 to-transparent">
                          <p class="text-xs text-white truncate">{{media.caption || 'Attachment'}}</p>
                        </div>
                        <!-- View Icon -->
                        <div class="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                          <svg class="h-6 w-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Comments Section -->
                  <div *ngIf="getTaskComments(selectedTask).length" class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <h3 class="text-lg font-medium text-gray-900 mb-4">Comments</h3>
                    <div class="space-y-4">
                      <div *ngFor="let comment of getTaskComments(selectedTask)" class="flex space-x-3">
                        <div class="flex-shrink-0">
                          <div class="h-8 w-8 rounded-full bg-indigo-100 flex items-center justify-center">
                            <span class="text-indigo-600 font-medium">{{getCommentUserInitial(comment)}}</span>
                          </div>
                        </div>
                        <div class="flex-1 min-w-0">
                          <div class="flex items-center justify-between">
                            <p class="text-sm font-medium text-gray-900">{{getCommentUserName(comment)}}</p>
                            <p class="text-xs text-gray-500">{{comment.createdAt | date:'short'}}</p>
                          </div>
                          <p class="text-sm text-gray-700 mt-1">{{comment.text}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Footer -->
              <div class="sticky bottom-0 bg-white border-t border-gray-200 p-4">
                <div class="flex justify-end space-x-4">
                  <button (click)="selectTask(null)"
                          class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    Close
                  </button>
                  <button (click)="acknowledgeCompletion(selectedTask)"
                          [disabled]="selectedTask.taskCompleted"
                          class="px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed">
                    {{selectedTask.taskCompleted ? 'Task Completed' : 'Complete Request'}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Confirmation Modal -->
    <lib-confirmation-modal-tw
      [isOpen]="isCompleteConfirmOpen"
      title="Complete Request"
      message="Are you sure you want to mark this request as complete? This action cannot be undone."
      confirmButtonText="Yes, Complete"
      cancelButtonText="Cancel"
      (confirm)="confirmCompleteTask()"
      (cancel)="cancelCompleteTask()"
      type="approve">
    </lib-confirmation-modal-tw>
  </div>
</div> 